import type { Language } from '../../../../../../common/types/i18n.js'
import { formatDisplayDate } from '../../../../../../common/utils/format-utils.js'
import type {
    NextEventPayload,
    OrganizedEvent,
} from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'

const formatEventStart = (iso: string, lang: Language): string => {
    const [datePart, timePart] = iso.split('T')
    if (!timePart) return formatDisplayDate(datePart, 'short', lang)
    const hhmm = timePart.slice(0, 5)
    return `${formatDisplayDate(datePart, 'short', lang)} ${hhmm}`
}

export const NextInternalEventCard = ({
    data,
    lang,
}: {
    data: NextEventPayload & { event: OrganizedEvent }
    lang: Language
}) => {
    return (
        <>
            <span className="portal-card__value">{data.event.name}</span>
            <span className="portal-card__subtext">
                {formatEventStart(data.event.startsAt, lang)}
            </span>
        </>
    )
}
